import React from 'react'
import Dashboard from '../../shared/dashboard/Dashboard'
import ApprovePopup from '../../shared/ApprovePopup'
import { useSelector } from 'react-redux'

const StudentDetail = () => {
  const open = useSelector((state) => state.approvePopupOpen)

  return (
    <>
      {/* {open && (<ApprovePopup open={true} />)} */}
      <Dashboard title={'Admin Dashboard'} />
    </>
  )
}

export default StudentDetail